import React from 'react';
import styled from 'styled-components'
import Utils from './Utils'

import PageWrapper from './PageWrapper';
import { HumanFace, Robot, SupportAgent, MixerLogo } from './Components';

import { SessionClickableContainer, SessionInfoContainer, InstructionDivider, RowFlexDiv, ColFlexDiv, MixerlabText } from './Components';

const TimeScheduleBox = styled.div`
  border-color: #204860;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-weight: 700;
  border-radius: 7px;
  border: 2px solid #204860;
  background: #D5DCE07D;
  margin: 10px;
  padding: 10px;
`;

const JoinSessionButton = styled.button`
  border-radius: 4px;
  background: #FEDC91;
  width: 100;
  height: 35px;
  border-color: #FEDC91;
  flex-shrink: 0;
  flex-grow: 0;
`

const DotDotLine = styled.div`
  color: #20486047;
  border-bottom: dashed 1.5px;
  flex-grow: 1;
  margin: 10px;
  height: 35px;
  width: 80%;
`

class ActorHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {sessionSchedule: []}
  }

  componentDidMount() {
    this.setState({
      sessionSchedule: JSON.parse(this.props.sessionSchedule.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")),
      activeSession: this.props.activeSession,
      activeSessionName: this.props.activeSessionName.replaceAll("&#39;", "\'").replaceAll("&#34;", "\""),
      botSession: this.props.botSession,
      botTrainingSession: this.props.botTrainingSession,
    })
    this.updateState()
  }

  updateState() {
    Utils.apiGet(
      '/actor/actor_home_updates').then((response) => {
        this.setState({'activeSession': response.data.active_session,
                      'activeSessionName': response.data.active_session_name,
                      'botSession': response.data.bot_session,
                      'botTrainingSession': response.data.bot_training_session,
                    })
    }).then(() => {this.updateStatePeriodically()});
  }

  updateStatePeriodically() {
    if (this.periodicStatusCheck) {
      window.clearTimeout(this.periodicStatusCheck);
      this.periodicStatusCheck = null;
    }

    this.periodicStatusCheck = window.setTimeout(
      this.updateState.bind(this),
      60000
    );
  }

  changeTimezone(date, ianatz) {

    // suppose the date is 12:00 UTC
    var invdate = new Date(date.toLocaleString('en-US', {
      timeZone: ianatz
    }));
  
    // then invdate will be 07:00 in Toronto
    // and the diff is 5 hours
    var diff = date.getTime() - invdate.getTime();
  
    // so 12:00 in Toronto is 17:00 UTC
    return new Date(date.getTime() - diff); // needs to substract
  
  }

  renderNextSession() {
    let nextSession = this.state.sessionSchedule[0]
    let now = new Date()
    now = this.changeTimezone(now, 'America/Los_Angeles')
    let start_time = new Date(nextSession['start_time'])
    const oneMin = 60 * 1000;
    const oneHour = 60 * oneMin;
    const oneDay = 24 * oneHour;

    const dateDiff = start_time - now
    const diffDays = Math.round(Math.floor(dateDiff / oneDay));
    const diffHours = Math.round(Math.floor(dateDiff / oneHour - diffDays*24));
    const diffMins = Math.round(Math.ceil(dateDiff / oneMin - diffDays*24*60 - diffHours*60));

    return (
      <ColFlexDiv>
        <MixerlabText style={{'margin': '0px'}}>The Next Actor Session will begin in</MixerlabText>
        <RowFlexDiv>
          <TimeScheduleBox>{diffDays} days</TimeScheduleBox>
          <TimeScheduleBox>{diffHours} hours</TimeScheduleBox>
          <TimeScheduleBox>{diffMins} mins</TimeScheduleBox>
        </RowFlexDiv>
        <MixerlabText>Pay: ${nextSession['pay_per_minute'].toFixed(2)}/min, up to ${nextSession['max_per_conversation'].toFixed(2)} per conversation</MixerlabText>
      </ColFlexDiv>
    )
  }

  renderSessionSchedule() {
    let scheduleLines = this.state.sessionSchedule.map((session) => (
        <RowFlexDiv style={{'width': '100%'}}>
          <div>
            <MixerlabText style={{'fontSize': '12px', 'marginBottom': '0px'}}>{session['name']}</MixerlabText>
            <MixerlabText style={{'fontSize': '9px', 'margin': '0px', 'width':'150px'}}>(${session['pay_per_minute'].toFixed(2)}/min, up to ${session['max_per_conversation'].toFixed(2)}/call)</MixerlabText>
          </div>
          <DotDotLine/>
          <JoinSessionButton>{session['start_time']}</JoinSessionButton>
        </RowFlexDiv>
        )
    )

    return (
      <ColFlexDiv style={{'alignItems': 'start', 'padding': '20px 40px'}}>
        <MixerlabText>Upcoming Actor Sessions</MixerlabText>
        {scheduleLines}
      </ColFlexDiv>
    )
  }

  render() {
    const activeSession = parseInt(this.state.activeSession)
    const botSession = parseInt(this.state.botSession)
    const botTrainingSession = parseInt(this.state.botTrainingSession)

    // Render static screen for paused users
    if (this.props.isPaused == 1) {
      return (
        <PageWrapper isAdmin={this.props.isAdmin}>
          <MixerlabText>Your account has been paused because you have reached the annual tax limit allowable for gig work. Please return in the next calendar year!</MixerlabText>
        </PageWrapper>
      );
    }

    // Render both actor and bot sessions for M-I-X-E-R users
    if (this.props.tierActor !== 'Provisional') {
      return (
        <PageWrapper isAdmin={this.props.isAdmin}>
          {(!activeSession && !botSession) &&
            <SessionInfoContainer style={{'marginBottom': '0px', 'paddingTop': '20px', 'height': 'auto',}}>
              <RowFlexDiv><HumanFace/><SupportAgent/></RowFlexDiv>
              {(this.state.sessionSchedule.length===0) && <MixerlabText>No Actor Session currently scheduled. Please check back later.</MixerlabText>}
              {!(this.state.sessionSchedule.length===0) && this.renderNextSession()}
            </SessionInfoContainer>
          }
          {((!activeSession && !botSession) && !(this.state.sessionSchedule.length===0)) &&
            <SessionInfoContainer  style={{'marginTop': '0px', 'alignItems': 'stretch', 'height': 'auto'}}>
              {this.renderSessionSchedule()}
            </SessionInfoContainer>
          }
          {!activeSession &&
            <SessionInfoContainer>
              <RowFlexDiv><HumanFace/></RowFlexDiv>
              <MixerlabText>No Actor Session currently active. Please check back later.</MixerlabText>
            </SessionInfoContainer>
          }
          {!!activeSession &&
            <SessionClickableContainer onClick={() => window.location.href='/actor/actor_session'}>
              <RowFlexDiv><HumanFace/><SupportAgent/></RowFlexDiv>
              <MixerlabText>Join Actor Session: Call in and simulate short conversations with another live caller! </MixerlabText>
            </SessionClickableContainer>
          }
          {!botSession &&
            <SessionInfoContainer>
              <RowFlexDiv><Robot/></RowFlexDiv>
              <MixerlabText>No Bot Session currently active. Please check back later.</MixerlabText>
            </SessionInfoContainer>
          }
          {!!botSession &&
            <SessionClickableContainer onClick={() => window.location.href='/actor/bot_session/bot'}>
              <RowFlexDiv><Robot/></RowFlexDiv>
              <MixerlabText>Join Bot Session: Call in and generate data by talking with our voice bot!</MixerlabText>
            </SessionClickableContainer>
          }
        </PageWrapper>
      );
    }

    // Render just a bot session for training for proviional users
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <MixerlabText>You are a provisional user! To fully participate in Actor tasks, please complete the following training task! </MixerlabText>
          {!botTrainingSession &&
            <SessionInfoContainer>
              <RowFlexDiv><Robot/></RowFlexDiv>
              <MixerlabText>No Bot Training Session currently active. Please check back later.</MixerlabText>
            </SessionInfoContainer>
          }
          {!!botTrainingSession &&
            <SessionClickableContainer onClick={() => window.location.href='/actor/bot_session/bot_training'}>
              <RowFlexDiv><Robot/></RowFlexDiv>
              <MixerlabText>Join Bot Training Session: Call in and generate data by talking with our voice bot!</MixerlabText>
            </SessionClickableContainer>
          }
      </PageWrapper>

    )
  }
}

export default ActorHome;